import React from 'react';
import { I18n } from '@aws-amplify/core';

import { RISK_LEVEL_COLORS, RISK_LEVEL_LABEL_KEYS } from '../../Constants';
import { useResultData } from '../../hooks/useResultData';
import { ActionPlanModal } from '@/components/ActionPlan';
import { KIM_LHC_ORIGIN_NAME } from '../constants';

import * as S from '../../styles';

interface KimLhcActionPlanModalProps {
	open: boolean;
	actionPlanId?: string;
	onClose: () => void;
}

export function KimLhcActionPlanModal({
	open,
	actionPlanId,
	onClose
}: Readonly<KimLhcActionPlanModalProps>): JSX.Element {
	const { data: resultData } = useResultData();

	const worstRiskLevel = resultData?.result.womanRiskLevel ?? RISK_LEVEL_LABEL_KEYS.HIGH;
	const worstRiskLevelLabel = I18n.get(
		RISK_LEVEL_LABEL_KEYS[worstRiskLevel as keyof typeof RISK_LEVEL_LABEL_KEYS] ?? ''
	);
	const worstRiskLevelColor = RISK_LEVEL_COLORS[worstRiskLevel as keyof typeof RISK_LEVEL_COLORS];

	return (
		<ActionPlanModal
			open={open}
			onClose={onClose}
			table_origin="kim_lhc_reports"
			table_origin_id={resultData?.id ?? ''}
			file_id={resultData?.information.fileId ?? ''}
			workstation_id={resultData?.information.workstationId ?? ''}
			origin_name={KIM_LHC_ORIGIN_NAME ?? ''}
			action_plan_id={actionPlanId}
			setActionPlanId={(_id: string) => onClose()}
			risk={<S.ScoreBadge style={{ backgroundColor: worstRiskLevelColor }}>{worstRiskLevelLabel}</S.ScoreBadge>}
			resetForm={true}
		/>
	);
}
